export const buildResubmissionRecord = (
    data: { id: string; resubmission: number | null }[],
): Record<string, number> => {
    return Object.fromEntries(
        data
            .filter((lr): lr is { id: string; resubmission: number } => lr.resubmission != null)
            .map((lr) => [lr.id, lr.resubmission]),
    );
};
